import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import EmptyRow from "../../components/emptyRow/EmptyRow";
import Contact from "./sections/Contact";
import DeclarationsNew from "./sections/DeclarationsNew";
import EthicsCounsellor from "./sections/EthicsCounsellor";
import HelpDocument from "./sections/HelpDocument";
import ReportCodeofConduct from "./sections/ReportCodeofConduct";
import "./Help.css";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  GetCounsellors,
  selectCounsellors,
} from "../../features/helpandassistance/counsellorSlice";
import {
  GetContacts,
  selectContacts,
} from "../../features/helpandassistance/contactsSlice";
import Feedback from "../../components/feedbackNote/Feedback";
import {
  GetLogsTracker,
  selectLogsTracker,
} from "../../features/login/logsTracker";
import { fetchLogsTracker } from "../../features/login/loginAPI";
import Card from "../../components/card/Card";
import { isPermited } from "../../features/localStorage";
import {
  GetCounsellorModule,
  selectCounsellorModule,
} from "../../features/learning/CounsellorSlice";
import EthicsCounsellorEdit from "../learning/admin/EthicsCounsellorEdit";

const Help = () => {
  const counsellors = useAppSelector(selectCounsellors);
  const contacts = useAppSelector(selectContacts);
  const CounsellorModule = useAppSelector(selectCounsellorModule);

  const rowConsellArrayData = CounsellorModule?.slice(0, 4);
  const consellList: any = rowConsellArrayData;

  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  const dispatch = useAppDispatch();
  var searchParams = {
    companyId: 0,
    keyword: "*",
  };

  useEffect(() => {
    async function fetchCounsellors() {
      await dispatch(GetCounsellors(searchParams));
    }
    fetchCounsellors();

    async function fetchContacts() {
      await dispatch(GetContacts(searchParams));
    }
    fetchContacts();

    let payloadCounseller = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    async function fetchConsellerModuleData() {
      let sample = await dispatch(GetCounsellorModule(payloadCounseller));
    }
    fetchConsellerModuleData();
  }, []);

  const fetchEthicsModuleData = () => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    dispatch(GetCounsellorModule(data));
  };

  const LogsTracker = useAppSelector(selectLogsTracker);
  var moduleName = "Help";
  useEffect(() => {
    async function fetchLogsTracker() {
      let sample = await dispatch(GetLogsTracker(moduleName));
    }
    fetchLogsTracker();
  }, []);

  return (
    <>
      <Feedback pageName="Help and Assistance" />

      <Row xs={12} className="mob mt-0 mb-4" style={styles.head}>
        Help and assistance
      </Row>
      <Row xs={12}>
        {/* <Col xs={12} sm={5} className="pb-4 mob-lr-padding0" >
          <div className="b_shadow rowBg1">
            <Row style={{ padding: "5px" }}>
              <Col sm={12}>
                <Contact contacts={contacts} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={12} sm={{ span: 7 }} className="pb-4 mob-lr-padding0" >
          <div className="b_shadow rowBg1" style={{ height: "100%" }}>
            <Row style={{ padding: "5px", height: "100%" }}>
              <Col xs={12} sm={12}>
                <ReportCodeofConduct />
              </Col>
            </Row>
          </div>
        </Col> */}
        <Col xs={12} sm={12} className="pb-4 mob-lr-padding0">
          <div className="b_shadow rowBg1">
            <Row style={{ padding: "5px" }}>
              <Col xs={12} sm={12}>
                <EthicsCounsellor counsellors={counsellors} />
              </Col>
            </Row>
          </div>
        </Col>

        {isPermited(2, 1) && (
          <Col
            xs={12}
            sm={12}
            className="pb-4"
            style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem" }}
          >
            <div className="b_shadow" style={{ height: "80%" }}>
              <Card
                type={2}
                title={"Ethics Counsellor Learning Programs"}
                data={consellList}
                fetchLearningModuleData={fetchEthicsModuleData}
                modal={
                  <>
                    <EthicsCounsellorEdit data={CounsellorModule} />
                  </>
                }
              />
            </div>
          </Col>
        )}

        {/* {isPermited(14, 1) && (
          <Col xs={12} sm={12} className="pb-4 mob-lr-padding0">
            <div className="b_shadow rowBg1">
              <Row style={{ padding: "5px" }}>
                <Col xs={12} sm={12}>
                  <DeclarationsNew />
                </Col>
              </Row>
            </div>
          </Col>
        )} */}

        {/* ----- Removed documents section as per instructions from Jyotsana Mandal during Teams meeting held on 14th Aug 2023 -----------*/}
        {/* <Col xs={12} sm={12} className="pb-4 mob-lr-padding0">
          <div style={{ margin: "0px 2px" }}>
            <Row style={{ padding: "0px 10px" }}>
              <Col xs={12} sm={12}>
                <HelpDocument />
              </Col>
            </Row>
          </div>
        </Col> */}
      </Row>
    </>
  );
};

const styles: any = {
  head: {
    fontFamily: "Saira",
    fontSize: "24px",
    fontWeight: "550",
    marginTop: "10px",
  },
};

export default Help;
